import {IListRegion} from "../../../../region/types/IListRegion";
import {generalRankingKeys, generalRankingKeysType} from "../../../constants/ranking";
import {IOfferRankingOptionValue} from "../../../types/IOfferRankingFormOptionValue";
import {getRankingCitiesIdByYear} from "../../../utils/get_ranking_cities_ids";

interface IGetOfferRankingFormCityOptions {
    year?: string;
    regionList?: IListRegion[];
}

export function getOfferRankingFormCityOptions(params: IGetOfferRankingFormCityOptions): IOfferRankingOptionValue[] {
    const {year, regionList} = params;

    if (!regionList || regionList.length === 0) {
        return [];
    }

    const cities = year && generalRankingKeys.includes(year) ? getRankingCitiesIdByYear(year as generalRankingKeysType) : getRankingCitiesIdByYear();

    return cities.reduce((acc, city) => {
        const region = regionList.find((region) => region.id === city);
        if (region) {
            return [...acc, {label: region.name, value: region.slug}];
        }
        return acc;
    }, [] as IOfferRankingOptionValue[]);
}
